import { render, staticRenderFns } from "./Allergen.vue?vue&type=template&id=18652f34&scoped=true"
import script from "./Allergen.vue?vue&type=script&lang=js"
export * from "./Allergen.vue?vue&type=script&lang=js"
import style0 from "./Allergen.vue?vue&type=style&index=0&id=18652f34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18652f34",
  null
  
)

export default component.exports